import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Image, Alert } from 'react-bootstrap';
import { viewProfile } from '../../../services/Dashboard';
import avatar from '../../../images/avatar/1.jpg'

const ProfilePage = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);



    const profileSrc = profile?.img
      ? `${process.env.REACT_APP_API_RESOURCE_URL}${profile.img}`
      : avatar;

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setLoading(true);
                const data = await viewProfile();
                setProfile(data);
                setError(null);
            } catch (err) {
                setError('Failed to load profile data. Please try again later.');
                console.error('Error fetching profile:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    if (loading) {
        return (
            <div id='preloader-inner'>
            <div className='sk-three-bounce-inner'>
                <div className='sk-child sk-bounce1'></div>
                <div className='sk-child sk-bounce2'></div>
                <div className='sk-child sk-bounce3'></div>
                <div id='preloader-inner-bg'></div>
            </div>
        </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger">
                {error}
            </Alert>
        );
    }

    return (
        <div className="profile-page">
            <Card>
                <Card.Body>
                    <Row>
                        <Col md={4} className="text-center mb-4 mb-md-0 ">
                            <div className="d-flex flex-column justify-content-center align-items-center ">
                                {profile?.img ? (
                                    <Image 
                                        src={profileSrc} 
                                        alt="Profile" 
                                        roundedCircle 
                                        className="profile-image mb-3"
                                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div 
                                        className="profile-avatar-letter mb-3 d-flex justify-content-center align-items-center rounded-circle"
                                        style={{ 
                                            width: '150px', 
                                            height: '150px', 
                                            backgroundColor: '#f2b416', 
                                            color: 'white',
                                            fontSize: '64px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {profile?.restaurant ? profile.restaurant.charAt(0).toUpperCase() : 'U'}
                                    </div>
                                )}
                                <h5 className="mt-2">{profile?.full_name}</h5>
                                <p className="text-primary mb-1">{profile?.role}</p>
                                <p className="text-muted">{profile?.restaurant}</p>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="profile-details">
                                <h3 className="mb-3">Profile Information</h3>
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <p className="text-muted mb-0">Full Name</p>
                                    </Col>
                                    <Col sm={8}>
                                        <p className="font-weight-medium mb-0">{profile?.full_name}</p>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <p className="text-muted mb-0">Email</p>
                                    </Col>
                                    <Col sm={8}>
                                        <p className="font-weight-medium mb-0">{profile?.email}</p>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <p className="text-muted mb-0">Restaurant</p>
                                    </Col>
                                    <Col sm={8}>
                                        <p className="font-weight-medium mb-0">{profile?.restaurant}</p>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <p className="text-muted mb-0">Role</p>
                                    </Col>
                                    <Col sm={8}>
                                        <p className="font-weight-medium mb-0">{profile?.role}</p>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <p className="text-muted mb-0">Owner ID</p>
                                    </Col>
                                    <Col sm={8}>
                                        <p className="font-weight-medium mb-0">{profile?.ownerid}</p>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col sm={4}>
                                        <p className="text-muted mb-0">Status</p>
                                    </Col>
                                    <Col sm={8}>
                                        <p className="font-weight-medium mb-0">
                                            <span className={`badge text-white ${profile?.status ? 'bg-success ' : 'bg-danger'}`}>
                                                {profile?.status ? 'Active' : 'Inactive'}
                                            </span>
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};

export default ProfilePage;